export default __webpack_public_path__ + "static/media/Conversant Mantle of the Living Legend.a0d29b32.jpg";